import { Formik, Form, Field, ErrorMessage } from 'formik';
import React, {useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import "../../../src/assets/css/App.css"
import { AUTH_URL } from '../../../src/configs/AppConfig';
// import { BsPerson } from "react-icons/bs";


const errorM = () => {
  message.error('Username or Password is wrong');
};

export default function SignIn() {
  
  const [isLoading , setIsLoading] = useState(false);
  const navigate = useNavigate()
  function handleRedirct() {
    navigate('/admin/');
  }
  return (
    <>
     <div className="animation-img">
       </div>
    <div className="flex items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start login-inputs">
      {/* Sign in section */}
      <div className="w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 ">
        <h4 className="login-text">
          LOGIN
        </h4>
        <p className="details-text">
          Enter your account details
        </p>
        <div>

     <Formik
       initialValues={{ userName: '', password: ''}}
       validate={values => {
         const errors = {};
         if (!values.userName) {
           errors.userName = 'Required';
         } 
         else if (!values.password) {
          errors.password = 'Required';
        }
        //  else if (
        //    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        //  ) {
        //    errors.email = 'Invalid email address';
        //  }
         return errors;
       }}
       onSubmit={(values ,{setSubmitting}) => {
        setIsLoading(true);
       axios.post(`${AUTH_URL}login`, {
          userName: values.userName.trim(),
          password: values.password.trim()
        })
        .then(function (response) {
          const token = response?.data.access_token
          localStorage.setItem('token', token);
          setIsLoading(false);
          handleRedirct()
          // localStorage.setItem('refreshToken', refreshToken);
          // return response.data.access_token
          
        })
        .catch(function (error) {
          errorM()
          console.log(error);
          setIsLoading(false);
        });
         }
      }
     >
       {({ isSubmitting }) => (
         <Form>
           <Field type="text" placeholder="Username" name="userName" id="userName" className={`flex h-12 w-full items-center justify-center border bg-white/0 p-3 outline-none inputs-css`}/>
           <ErrorMessage name="userName" component="div" id="erroMassage" />
           <Field type="password" placeholder="Password" name="password" id="password" className={`flex h-12 w-full items-center justify-center border bg-white/0 p-3 outline-none inputs-css`} />
           <ErrorMessage name="password" component="div" id="erroMassage" />
          <Link to="/auth/forget-password" className="text-brand-500 hover:text-brand-600 dark:text-white forgetPass">Forget Password ?</Link> 
                     
           <button type="submit" disabled={isLoading} className="linear w-full py-[12px] text-base transition duration-200 hover:bg-brand-600 active:bg-brand-700 login-btn">
           Login
           </button>
         </Form>
       )}
     </Formik>
   </div>
      </div>
    </div></>
  );
}
